import MarketingImage from '@/components/landing/MarketingImage';
import React from 'react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
const landingLogo = '/images/marketing/landing-logo-2.webp';
const brandMarkLogo = '/images/marketing/lovable-uploads-cc1c4082-b52d-4f93-9c6a-0bc389e4be79.webp';

interface LogoProps {
  variant?: 'default' | 'landing';
}

const Logo: React.FC<LogoProps> = ({ variant = 'default' }) => {
  const isMobile = useIsMobile();

  if (variant === 'landing') {
    return (
      <div className="flex min-w-0 items-center">
        <Link to="/" className="flex min-w-0 items-center" aria-label="CalorieScience home">
          <MarketingImage loading="eager"
            src={landingLogo}
            alt="CalorieScience"
            className="block h-auto w-[9rem] sm:w-[11rem] lg:w-[11.5rem] xl:w-[12.5rem] 2xl:w-[15.5rem]"
          />
        </Link>
      </div>
    );
  }

  return <div className="flex flex-col items-center">
      <Link to="/" className="flex flex-col items-center">
        <div className="flex items-center">
          <div className="mr-1">
            <MarketingImage loading="eager" src={brandMarkLogo} alt="CalorieScience Logo" className={`${isMobile ? 'h-6' : 'h-8'} w-auto`} />
          </div>
          <div className={`flex-shrink-0 font-heading font-bold ${isMobile ? 'text-xl' : 'text-2xl'}`}>
            <span className="text-cs-secondary">Calorie</span>
            <span className="text-cs-primary">Science</span>
          </div>
        </div>
        {!isMobile && <div className="w-full flex justify-center">
            <span className="text-xs text-gray-600 mt-1 font-manrope text-center">   Personalized. Intelligent. Scalable.</span>
          </div>}
      </Link>
    </div>;
};
export default Logo;
